// import { __ } from '@wordpress/i18n';
// import { Headers } from '../../types/quote';
// import { Slot } from '@wordpress/components';
// import { STATUS_LABELS } from '../../constants';
//
// interface StatusTabsProps {
//     currentStatus: string;
//     headers: Headers;
//     onStatusChange: ( status: string ) => void;
//     children?: React.ReactNode;
// }
//
// const StatusTabs: React.FC< StatusTabsProps > = ( {
//     headers,
//     currentStatus,
//     onStatusChange,
// } ) => {
//     const statusCounts = headers?.statusCounts;
//     const statusLabels = {
//         all: __( 'All', 'dokan' ),
//         ...STATUS_LABELS,
//     };
//
//     console.log( statusLabels, '::::::::::::::statusLabels' );
//
//     return (
//         <div className="my-4">
//             <nav className="flex py-3" aria-label="Tabs">
//                 { Object.keys( statusLabels ).map( ( key ) => (
//                     <button
//                         key={ key }
//                         onClick={ () => onStatusChange( key ) }
//                         className={ `px-2 text-xs font-medium hover:bg-transparent whitespace-nowrap border-solid border-r last:border-0 border-gray-400 leading-none focus:outline-none first:pl-0 ${
//                             currentStatus === key
//                                 ? 'active-title'
//                                 : 'text-gray-500 hover:text-gray-700'
//                         }` }
//                     >
//                         { statusLabels[ key ] } (
//                         { ( key === 'all'
//                             ? headers?.statusTotal
//                             : statusCounts?.[ key ] ) || 0 }
//                         )
//                     </button>
//                 ) ) }
//             </nav>
//         </div>
//     );
// };
//
// export default StatusTabs;

import { __ } from '@wordpress/i18n';
import { Headers } from '../../types/quote';
import { STATUS_LABELS } from '../../constants';
import { DokanTab } from '@dokan/components';

interface StatusTabsProps {
    currentStatus: string;
    headers: Headers;
    onStatusChange: ( status: string ) => void;
}

interface Tab {
    name: string;
    title: string;
    className?: string;
    disabled?: boolean;
}

const StatusTabs = ( {
    headers,
    currentStatus,
    onStatusChange,
}: StatusTabsProps ) => {
    const statusCounts = headers?.statusCounts || {};

    // @ts-ignore
    const statusLabels = wp.hooks.applyFilters( 'dokan_quote_status_labels', {
        all: __( 'All', 'dokan' ),
        ...STATUS_LABELS,
    } );

    // Convert status labels to DokanTab format
    const tabs: Tab[] = Object.entries( statusLabels ).map(
        ( [ key, label ] ) => ( {
            name: key,
            title: `${ label } (${
                ( key === 'all'
                    ? headers?.statusTotal
                    : statusCounts?.[ key ] ) || 0
            })`,
            className: 'text-xs font-medium mr-3',
        } )
    );

    // @ts-ignore
    const filteredTabs = wp.hooks.applyFilters(
        'dokan_quote_status_tabs',
        tabs,
        headers,
        currentStatus
    );

    return (
        <div className="my-4">
            <DokanTab
                tabs={ filteredTabs }
                onSelect={ onStatusChange }
                initialTabName={ currentStatus }
            ></DokanTab>
        </div>
    );
};

export default StatusTabs;
